import { EditorShell } from '@/components/editor/EditorShell';
import { navigate } from '@/lib/nav';
import { useEditorStore } from '@/lib/state/editorStore';
import { useFicheStore } from '@/lib/state/ficheStore';
import { useEffect } from 'react';

interface EditorRouteProps {
  ficheId: string;
}

export function EditorRoute({ ficheId }: EditorRouteProps) {
  const fiche = useFicheStore((s) => s.fiches[ficheId]);
  const loadedFiche = useEditorStore((s) => s.fiche);
  const loadFiche = useEditorStore((s) => s.loadFiche);

  // Sync the requested fiche into the editor store on mount or when the id changes.
  // loadFiche() also resets past/future stacks internally.
  useEffect(() => {
    if (!fiche) return;
    if (loadedFiche?.id !== fiche.id) {
      loadFiche(fiche);
    }
  }, [fiche, loadedFiche?.id, loadFiche]);

  if (!fiche) {
    return (
      <main
        data-testid="editor-not-found"
        className="min-h-screen px-4 py-16 flex items-start justify-center"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 30%, rgba(255,200,140,.18), transparent 40%), radial-gradient(circle at 80% 70%, rgba(140,180,255,.15), transparent 45%), linear-gradient(#ece5d2, #e0d8c0)',
        }}
      >
        <div
          className="max-w-md w-full rounded-card px-6 py-8 text-center"
          style={{
            background: '#fdfaf1',
            border: '2.5px solid #1f2330',
            boxShadow: '0 12px 28px rgba(60,40,20,.18)',
          }}
        >
          <div className="text-5xl mb-2" aria-hidden>
            🔎
          </div>
          <h1 className="font-gloock text-xl text-ink">Fiche introuvable</h1>
          <p className="font-hand text-[15px] text-ink-soft mt-2">
            Cette fiche n'est pas en mémoire. Phase 8 (persistance IndexedDB) la rendra accessible
            après rechargement.
          </p>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="mt-5 px-4 py-2 bg-accent-yellow text-ink font-gloock text-[15px] border-[2.5px] border-ink rounded-card shadow-ink-sm"
          >
            ← Nouvelle fiche
          </button>
        </div>
      </main>
    );
  }

  // Wait one render after load so editorStore.fiche is set before the shell mounts.
  if (loadedFiche?.id !== fiche.id) return null;

  return <EditorShell ficheIdShort={fiche.id.slice(0, 8)} />;
}
